import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const ScoreBoardBlock = ({ item, community_id, season_id, challenge_id, activity_id }) => {
  return (
    <Card className="mb-2">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{item.challenge_name || "Challenge"}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-primary">{item.score || 0}</div>
            <div className="text-xs text-gray-500">Score</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-green-600">{item.completed || 0}</div>
            <div className="text-xs text-gray-500">Completed</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-gray-600">{item.total || 0}</div>
            <div className="text-xs text-gray-500">Total</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ScoreBoardBlock;
